import { css, type Theme } from "@emotion/react";

export const envelope = (theme: Theme) => css`
  &&& {
    path {
      color: ${theme.success.textBase};
    }
  }

  margin-left: -0.25rem;
  margin-right: 1.25rem;
`;

export const continueWithButton = css`
  margin-top: 1rem;
`;

export const fullWidth = css`
  width: 100%;
  text-align: center;
`;
